export default __webpack_public_path__ + "static/media/application-form-background.ece34282.png";